import { PardotFieldSelectionTable } from '../../../general/pardot-fields/PardotFieldSelectionTable';
import React from 'react';
export const FieldRelatedTechTab = ({ index, sonarObjectId }) => {
    const uri = `v3/core/sonar-objects/${sonarObjectId}/related-tech`;
    return React.createElement(PardotFieldSelectionTable, { parentIndex: index, uri: uri });
};
